import * as ThemeUI from 'theme-ui'

/**
 * This stuff fixes type issues around re-exporting elements straight from theme-ui
 * Otherwise you have to import straight from theme-ui in dependent repositories
 */

export type BoxProps = ThemeUI.BoxProps
export const Box = ThemeUI.Box

export type FlexProps = ThemeUI.FlexProps
export const Flex = ThemeUI.Flex

export type GridProps = ThemeUI.GridProps
export const Grid = ThemeUI.Grid

export type TextProps = ThemeUI.TextProps
export const Text = ThemeUI.Text

export type LinkProps = ThemeUI.LinkProps
export const Link = ThemeUI.Link

export type ImageProps = ThemeUI.ImageProps
export const Image = ThemeUI.Image

export type ProgressProps = ThemeUI.ProgressProps
export const Progress = ThemeUI.Progress

export type DonutProps = ThemeUI.DonutProps
export const Donut = ThemeUI.Donut

export type EmbedProps = ThemeUI.EmbedProps
export const Embed = ThemeUI.Embed

export type CardProps = ThemeUI.CardProps
export const Card = ThemeUI.Card

export type LabelProps = ThemeUI.LabelProps
export const Label = ThemeUI.Label

export type ContainerProps = ThemeUI.ContainerProps
export const Container = ThemeUI.Container

export type ParagraphProps = ThemeUI.ParagraphProps
export const Paragraph = ThemeUI.Paragraph

export type ThemeStyleObject = ThemeUI.ThemeUIStyleObject

export type Theme = ThemeUI.Theme
